import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BrowserSupportService {
  isSupported(): boolean {
    return (
      typeof window.Promise !== 'undefined' &&
      typeof window.fetch !== 'undefined' &&
      typeof Proxy !== 'undefined' &&
      typeof CSS !== 'undefined' &&
      typeof CSS.supports === 'function' &&
      CSS.supports('--a', '0')
    );
  }
}
